<script setup lang="ts">
import FormFieldCell from './FormFieldCell.vue'
import type { WidgetAttributes } from '../utils/claim-editor'
import { useClaimFormContext } from '../composables/fields'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  name: string
  attributes: WidgetAttributes
}>()

const { state } = useClaimFormContext()
</script>

<template>
  <FormFieldCell :name="props.name">
    <UInput
      v-model.optional="state[props.name]"
      v-bind="attributes"
      :name="props.name"
      class="w-full"
      :ui="{ base: 'p-2 rounded-none' }"
      size="xs"
      type="date"
      variant="none"
    />
  </FormFieldCell>
</template>
